import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { MatSlider, MatSliderThumb } from "@angular/material/slider";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { DecimalPipe } from "@angular/common";
import { DetectionObject } from "../../../model/detection/detection.models";
import { ColorSwatchPickerComponent } from "../../../../shared-components/color-swatch-picker/color-swatch-picker.component";

@Component({
  selector: "lib-object-row",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSlider, MatSliderThumb, MatIconButton, MatIcon, MatFormField, MatInput, DecimalPipe, ColorSwatchPickerComponent],
  templateUrl: "./object-row.component.html",
  styleUrl: "./object-row.component.scss",
  host: {
    "[style.--obj-color]": "object().color",
    "[class.lib-object-row--disabled]": "disabled()",
  },
})
export class ObjectRowComponent {
  readonly object = input.required<DetectionObject>();

  readonly disabled = input(false);

  readonly colorChanged = output<string>();

  readonly thresholdChanged = output<number>();

  readonly nameChanged = output<string>();

  readonly removed = output<string>();

  protected onNameChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.nameChanged.emit(value);
  }
}
